$(function(){
	var pathname = $(location).attr('pathname');
	// ページ内スクロール
	var headerHeight = $('#p-global-header').outerHeight() || 0;
	var urlHash = location.hash;
	if(urlHash) {
		$('body,html').stop().scrollTop(0);
	    setTimeout(function(){
			var target = $(urlHash);
			var position = target.offset().top - headerHeight;
			$('body,html').stop().animate({scrollTop:position}, 500, 'swing');
	    }, 100);
	}
	
	$('a[href*="#"]').click(function(){
	  	var href= $(this).attr('href');
	  	if (href.indexOf(pathname) > -1) {
	  		href = href.substr(href.indexOf('#'));
	  		var target = $(href);
	  		var position = target.offset().top - headerHeight;
	  		$('body,html').stop().animate({scrollTop:position}, 500, 'swing');
		} 
	});
	
	// ヘッダー表示・非表示
	var prevScrollPos = $(window).scrollTop();
	var scrollThreshold = 300;
	
	$(window).scroll(function() {
		var currentScrollPos = $(window).scrollTop();
		if (currentScrollPos < 5) {
			$('#p-global-header').removeClass('p-border');
		} else {
			$('#p-global-header').addClass('p-border');
		}
		if (currentScrollPos > scrollThreshold) {
			// ページ上部から300px下にスクロールした場合
			if (prevScrollPos > currentScrollPos) {
				// 上にスクロールしている場合、30px以上上にスクロールしているかチェック
				if (currentScrollPos < (prevScrollPos - 40)) {
					$('#p-global-header').removeClass('p-hide');
				}
			} else {
				// 下にスクロールしている場合、.hidebarクラスを削除
				$('#p-global-header').addClass('p-hide');
			}
		} else {
			$('#p-global-header').removeClass('p-hide');
		}
	
		prevScrollPos = currentScrollPos;
	});
	
	// クリップボードへのコピー
	  var clipboard = new ClipboardJS('#copy-btn');
	  clipboard.on('success', function(e) {
		  showTooltip();
		  e.clearSelection();
	  });
	  
	  function showTooltip() {
		  $("#copy-btn").addClass("success");
		  setTimeout(() => {
			  $("#copy-btn").removeClass("success");
		  }, 1200);
	  }
});	
